
/**
 * Firestore notices 컬렉션의 Notice 문서 인터페이스
 */
export interface Merchant {
  category_code: string;
  deal_id: string;
  kindred_id: string;
  merchant_id: string;
  merchant_image_url: string;
  merchant_name: string;
  recommended: boolean;
  allowedUsers: string[] | null; // isPublic이 false일 때만 사용
  allowedEnterprises: string[] | null; // isPublic이 false일 때만 사용
}

/**
 * Merchant 컬렉션 경로 상수
 */
export const MERCHANT_COLLECTION = process.env.REACT_APP_MERCHANTS_COLLECTION as string;